var __webpack_exports__ = {};
/*!*********************************************!*\
  !*** ./scripts/components/back-in-stock.js ***!
  \*********************************************/
class BackInStock extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.success = this.querySelector('[data-success]');
    this.error = this.querySelector('[data-error]');
  }
  handleSubmit(event) {
    event.preventDefault();
    const formData = Object.fromEntries(new FormData(this.form));
    const variantID = document.querySelector(`product-form[data-section-id="${this.dataset.section}"] [name="id"]`)?.value;

    const payload = {
      data: {
        type: 'back-in-stock-subscription',
        attributes: {
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: formData.email
              }
            }
          },
          channels: ['EMAIL']
        },
        relationships: {
          variant: {
            data: {
              type: 'catalog-variant',
              id: `$shopify:::$default:::${variantID}`
            }
          }
        }
      }
    };

    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-10-15'
      },
      body: JSON.stringify(payload)
    };

    fetch(this.form.action, requestOptions)
      .then((result) => {
        this.form.classList.add('hidden');
        this.success.classList.remove('hidden');
      })
      .catch((error) => {
        console.log('error', error);
        this.form.classList.add('hidden');
        this.error.classList.remove('hidden');
      });
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
  }
}

customElements.get('back-in-stock') || customElements.define('back-in-stock', BackInStock);

